import {useContext} from 'react'
import RouteInfoContext from './context'

const useAlternativeRoutes = (): Record<string, Record<string, string>> => {
  const {alternativeRoutes} = useContext(RouteInfoContext)

  return alternativeRoutes ?? {}
}

export default useAlternativeRoutes
